import { SET_DUE_DATE_TYPE } from '../mutation-types';

// state
export const state = {
  dueDateType: null,
};

// mutations
export const mutations = {
  [SET_DUE_DATE_TYPE](currentState, dueDateType) {
    currentState.dueDateType = dueDateType;
  },
};

// actions
export const actions = {
  setDueDateType({ commit, currentState, dispatch }, id) {
    commit(SET_DUE_DATE_TYPE, id);
  },
};

// getters
export const getters = {
  dueDateType: currentState => currentState.dueDateType,
};
